// extracted by mini-css-extract-plugin
module.exports = {"custom-url-delete-action-button":"inspector_custom-url-delete-action-button__3ST3A"};